import { ErrorMessage, Props } from '@hookform/error-message'
import { FieldErrors, Path, FieldValues } from 'react-hook-form'
import styles from './validation.module.scss'

type FieldErrorMessageProps<T extends FieldValues> = {
  name: Path<T>
  errors: FieldErrors<T>
}

export function FieldErrorMessage<T extends FieldValues>({
  errors,
  name
}: FieldErrorMessageProps<T>) {
  return (
    <ErrorMessage
      errors={errors}
      name={name as unknown as Props<FieldErrors<T>, undefined>['name']}
      render={({ message }) => (
        <p className={styles.ErrorMessage} role="alert">
          {message}
        </p>
      )}
    />
  )
}
